import { isOpenPartnerProductOrderItemMemoInputModal } from "@/atoms/item/is-open-partner-product-order-item-memo-input-modal";
import { partnerProductOrderItemMemoValuesState } from "@/atoms/item/partner-product-order-item-memo-values-state";
import { selectedPartnerProductOrderCartItemsState } from "@/atoms/item/selected-partner-product-order-cart-items-state";
import { ButtonColor } from "@/common/enum/button-color";
import { ItemDetailLineDto } from "@/types/dto/item-detail-line-dto";
import { Button, Modal, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import validator from "validator";
import { H4 } from "../typography/H4";

export const PartnerProductOrderItemMemoInputModal = () => {
  const [isOpen, setIsOpen] = useRecoilState(
    isOpenPartnerProductOrderItemMemoInputModal
  );
  const [cartItems, setCartItems] = useRecoilState(
    selectedPartnerProductOrderCartItemsState
  );
  const setMemoValuesState = useSetRecoilState(
    partnerProductOrderItemMemoValuesState
  );
  const [localMemoValues, setLocalMemoValues] = useState<string[]>([]);

  const isActive = localMemoValues.every(
    (value) => !validator.isEmpty(value.trim())
  );

  useEffect(() => {
    if (isOpen) {
      setLocalMemoValues(new Array(isOpen.item.memos.length).fill(""));
    }
  }, [isOpen]);

  const handleCloseModal = () => {
    setIsOpen(undefined);
  };

  const handleMemoChange = (index: number, value: string) => {
    const newMemoValues = [...localMemoValues];
    newMemoValues[index] = value;
    setLocalMemoValues(newMemoValues);
  };

  const handleCartClick = () => {
    if (!isOpen) return;

    const memoItems = isOpen.item.memos.map((memo, index) => ({
      name: memo,
      value: localMemoValues[index],
    }));

    const cartItem: ItemDetailLineDto = {
      childItem: {
        ...isOpen.item,
        memoItems: memoItems,
      },
      quantity: isOpen.quantity,
    };

    setMemoValuesState((prev) => [
      ...prev,
      {
        itemId: isOpen.item.id,
        memoValues: localMemoValues,
      },
    ]);
    const newCartItems = [...cartItems, cartItem];
    setCartItems(newCartItems);
    setIsOpen(undefined);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal size="2xl" show={true} onClose={handleCloseModal}>
      <Modal.Header>
        <H4 className="text-semantic-text-heading">상품 메모 입력하기</H4>
      </Modal.Header>
      <Modal.Body className="max-h-[400px] overflow-y-auto">
        <div className="mb-4">
          <div className="p-4 bg-gray-50">
            상품 메모 입력이 필요한 상품입니다. <br />
            견적 발행 및 발주 이후 수정이 불가하므로 정확한 정보 입력
            부탁드립니다.
          </div>
        </div>
        <div className="flex flex-col gap-4">
          {isOpen.item.memos.map((memo, index) => (
            <div key={index} className="flex flex-col gap-2">
              <span className="min-w-[80px]">{memo}</span>
              <TextInput
                value={localMemoValues[index]}
                onChange={(e) => handleMemoChange(index, e.target.value)}
                placeholder="정보를 입력해주세요."
                className="flex-1"
                maxLength={100}
              />
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color={isActive ? ButtonColor.PRIMARY : ""}
          onClick={handleCartClick}
          disabled={!isActive}
        >
          장바구니 담기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
